module.exports = "### TickTock\n\n- Hello World doesn’t illustrate what React can do\n\n- More dynamic example\n\n- See React update only parts of the DOM that need updating\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/08_clock/notes_1.md
// module id = 1509
// module chunks = 0